export const en = {
  Navbar: {
    about_TOEIC: 'About TOEIC',
    must_know_vocabulary: 'Must-know Vocabulary',
    Biz_talk: 'BizTalk',
    newsletter: 'Newsletter',
    overview: 'Overview',
    essay_revision: 'Essay Revision',
    email_sentence: 'E-mail Sentence',
    challenge: 'Word Challenge',
    ai_helper: 'AI Assistant'
  },
  Course_Overview: {
    cefr_level: 'CEFR',
    A1: '（TOEIC<225）',
    A2: '（TOEIC 225-550）',
    B1: '（TOEIC 550-785）',
    B2: '（TOEIC 785-945）',
    C1: '（TOEIC>945）',
    C2: '（TOEIC>945）',
    course_category: 'Category',
    life: 'Life',
    biz: 'Biz',
    news: 'News',
    toeic: 'TOEIC',
    learning_resources: 'Learning Resources',
    unit_test: 'Unit Test',
    passed: 'Passed',
    unpassed: 'Unpassed'
  },
  Login: {
    register: 'Register',
    trial: 'Sigh up for free trial',
    login: 'Log In',
    log_out: 'Log Out',
    start_my_course: 'Start my course',
    // please_enter_your_email: 'Please Enter Your Email',
    please_enter_password: 'Please Enter Your Password',
    forgot_Password: 'Forgot Password',
    please_enter_your_email: 'Please Enter Your Email',
    send_verification_email: 'Send Verification Email'
  },
  Overview: {
    classify: 'Classify',
    time: 'Time',
    course: 'Course',
    practice: 'Practice',
    exam: 'Exam',
    exam_score: 'Exam score',
    exam_advance: 'Advance',
    exam_advance_with_percent: 'Advance with percent',
    writing_count: 'Writing count'
  },
  Home: {
    Daily_English: 'Daily English',
    World_News: 'World News',
    Lets_play_in_English: "Let's Play in English",
    FunEnglish: 'Play games, learn vocabulary, and improve English skills with your teacher!',
    Learning_History: 'Learning History',
    Latest_Courses: 'Latest Courses',
    Recommend: 'Course Recommendations',
    Learning_Guides: 'Learning Guides',
    Go_to_course: 'Go to Courses',
    Play: 'Play',
    Keep: 'Keep',
    watch_more: 'Watch more'
  },
  AI: {
    Home: {
      myPoints: 'My Points',
      pointUnit: 'points',
      viewUsageRecords: 'View Usage Records',
      geptBeginner: 'GEPT Beginner',
      geptIntermediate: 'GEPT Intermediate',
      pastExamQuestions: 'Past Exam Questions',
      mockTest: 'Mock Test',
      letterGenerator: 'Letter Generator',
      aiCorrection: 'AI Correction',
      speechScriptGenerator: 'Speech Script Generator',
      shadowingPractice: 'Shadowing Practice',
      noAiPointsDeducted: '(No AI points deducted)',
      guide: 'User Guide',
      generateLetter: 'Generate Letter',
      generateSpeech: 'Generate Speech Script',
      businessScenario: 'Business Scenario',
      lifeScenario: 'Life Scenario'
    },
    Records: {
      backToAIHelper: 'Back to AI Assistant',
      serialNumber: 'No.',
      usageTime: 'Usage Time',
      item: 'Item',
      pointsDeducted: 'Points Deducted',
      goTo: 'Go',
      noUsageRecords: 'No usage records',
      redeemConfirmTitle: 'Redeem {points} AI English Learning Classroom points?',
      currentTotalPoints: 'Current total points:',
      addPoints: 'Add {points} points',
      pointsAfterRedeem: 'Points after redemption',
      confirm: 'Confirm',
      cancel: 'Cancel',
      errorOccurred: 'An error occurred',
      redeemComplete: 'Redemption complete',
      redeemFailed: 'Redemption failed',
      redeemConfirmation: 'Redemption Confirmation'
    }
  },
  GEPT: {
    common: {
      geptPractice: 'GEPT Practice',
      quizWriting: 'GSAT Writing',
      points: 'points',
      logout: 'Log out',
      practiceOverview: 'Practice Overview',
      roundOverview: 'Round Overview',
      beginnerAndIntermediate: 'Elementary & Intermediate',
      mockAndPast: 'Mock Tests & Past Exams',
      speakingAndWriting: 'Speaking & Writing',
      speaking: 'Speaking',
      writing: 'Writing',
      speakingPractice: 'Speaking Practice',
      writingPractice: 'Writing Practice',
      practiceCount: 'Practice Count',
      notStarted: 'Not started yet',
      expiredRedeemAgain: 'Expired. Please redeem points again.',
      validTime: 'Valid through: {date}',
      noRecord: 'No records',
      viewRecord: 'View Records',
      startPractice: 'Start Practice',
      enterPractice: 'Enter Practice',
      selectPracticeItem: 'Select an item to practice',
      question: 'Question',
      answer: 'Answer',
      start: 'START',
      nextQuestion: 'Next Question',
      nextType: 'Next Section',
      submitReport: 'Submit and View Report',
      confirm: 'Confirm',
      back: 'Back',
      notice: 'Notice',
      errorOccurred: 'An error occurred',
      noExamRecord: 'Unable to get the exam record. Please try again later.',
      wordsCount: '{count} words entered',
      inputWords: 'Answer length: {count} words',
      wordUnit: 'words',
      scoreUnit: 'pts',
      noAnswer: 'No answer submitted',
      correction: 'Review',
      aiCorrection: 'AI Review',
      downloadReport: 'Download Report',
      totalScore: 'Total Score',
      referenceAnswer: 'Reference Answer',
      chineseTranslation: 'Chinese Translation:'
    },
    labels: {
      beginner: 'Elementary',
      intermediate: 'Intermediate',
      mockExam: 'Mock Test',
      pastExam: 'Past Exam Questions',
      allQuestions: 'All Questions',
      repeat: 'Repeat',
      readSentences: 'Read Sentences and Passage',
      answerQuestion: 'Answer Questions',
      describeImage: 'Describe Image',
      readPassage: 'Read Passage',
      describePicture: 'Picture Description',
      singleSentenceWriting: 'Single Sentence Writing',
      paragraphWriting: 'Paragraph Writing',
      chineseToEnglish: 'Chinese-to-English Translation',
      englishComposition: 'English Composition',
      sentenceRewrite: 'Sentence Rewrite',
      sentenceMerge: 'Sentence Combining',
      sentenceReorder: 'Sentence Reordering',
      pictureWriting: 'Picture Writing',
      firstPart: 'Part 1',
      secondPart: 'Part 2',
      thirdPart: 'Part 3',
      fourthPart: 'Part 4',
      fifthPart: 'Part 5',
      sixthPart: 'Part 6',
      partWithNumber: 'Part {number}'
    },
    alerts: {
      answerHint: 'Answer Hint',
      unfinishedSentence: '<p>Some sentences are not completed.</p>',
      scoreFailedTitle: 'Score Calculation Failed',
      scoreFailedText: 'Please try again later or contact customer service.',
      confirmCompleteTitle: 'Finish {name} {type} practice?',
      aiCorrectionDesc: 'After you confirm, please wait while the AI Assistant reviews your answers.',
      currentTotalPoints: 'Current total: {points} points',
      pointsToDeduct: 'Deduct: {points} points',
      pointsAfterDeduct: 'Points after deduction: {points} points',
      calculatingScore: 'Calculating score......',
      leaveTitle: 'Reminder',
      leaveText: 'The exam is not finished. If you leave now, your answers will not be submitted or recorded. Please confirm whether to leave this exam.',
      continueAnswering: 'Continue Answering',
      confirmLeave: 'Leave',
      pointNotice: 'Point Deduction Notice',
      askStart: 'Would you like to start?',
      deductAfterConfirm: '{points} points will be deducted after confirmation.',
      currentTotalLabel: 'Current total:',
      pointsToDeductLabel: 'Deduct:',
      pointsAfterDeductLabel: 'After deduction:',
      insufficientPoints: 'Insufficient points',
      insufficientPointsDesc: 'You do not have enough points for this course. Please purchase more on the LiveABC website.',
      purchaseUrl: 'Purchase'
    },
    speaking: {
      clickToPlayQuestion: 'Click to play the question',
      playFinished: 'Playback finished',
      listenCarefully: 'Listen carefully',
      answerAfterQuestion: 'After the question plays,<br>the microphone will start recording.<br>Please answer within the time limit.',
      pleaseAnswerQuestion: 'Please answer the question',
      recordingFinished: 'Recording finished',
      confirmRecording: 'Confirm Recording',
      recordingSuccess: 'Recording Saved',
      recordedNext: 'Recording saved.<br>Go to the next question.',
      skipCountdown: 'Skip countdown and start',
      beginnerReadHint: 'Read the questions during the 60-second countdown.<br>Finish reading all items within the time limit.',
      readHint: 'Read the question first. When the reading countdown ends, the microphone will start recording automatically. Please answer within the time limit.',
      recordingComplete: 'Recording complete',
      timeUpSubmit: 'Time is up. Please submit.',
      recordingItem: 'Recording S{number}',
      stopAfterReading: 'Tap stop when you finish reading.'
    },
    writing: {
      rewriteInstruction: 'Follow the prompt to rewrite the original sentence in the required form. Write the complete rewritten sentence, including the prompted words and punctuation.',
      placeholderAnswer: 'Enter your answer ...',
      sectionTitle: 'Part {label}  {name}',
      uploadImage: 'Upload Image',
      questionTitle: 'Question',
      clearAnswer: 'Clear Answer',
      translateDescription: 'Translate the following Chinese sentences into accurate, fluent, and natural English.',
      compositionDescription: 'Write an English composition based on the prompt. Use at least 120 words.',
      paragraphDescription: 'Write a short passage of about 50 words based on the pictures below.\nNote: Points will be deducted if your answer does not follow the prompt.',
      paragraphHint: 'This paragraph-writing section is scored holistically and then converted to a percentage score. It takes more time and has a higher score weight. Read the prompt and write an English passage of about 50 words based on the pictures. Key scoring areas include completeness, grammar, spelling, capitalization, and punctuation.<br/><br/>You can begin with a main idea, describe the events in order, avoid adding irrelevant details, use transitions to organize the passage, and end with your thoughts or feelings. Try describing key actions in the pictures first, pay attention to verb tense, and connect all three pictures into one coherent passage.'
    },
    testing: {
      audioPlayTest: 'Audio Playback Test',
      audioPlayDesc: 'Play the audio and check whether the sound works properly.',
      micTest: 'Microphone Test',
      micDesc: 'Speak into the microphone. If the waveform moves, your microphone is working.',
      inputTest: 'Input Test',
      inputPlaceholder: 'Type here......',
      inputDesc: 'Type English in the box to check that your device and input method are working.'
    },
    precautions: {
      beginnerSingleSentenceWriting: 'This test has two parts: Single Sentence Writing and Paragraph Writing. Single Sentence Writing includes sentence rewriting, sentence combining, and sentence reordering.<br/>The test time is 40 minutes. Select START below to begin.',
      beginnerParagraphWriting: 'This test has two parts: Single Sentence Writing and Paragraph Writing. In Paragraph Writing, write a short passage of about 50 words based on the prompt and three pictures.<br/>The test time is 40 minutes. Select START below to begin.',
      beginnerRepeat: 'This test has three parts: Repeat, Read Sentences and Passage, and Answer Questions. In Part 1, Repeat, there are five questions. Each question is played twice through your headphones, with about one to two seconds between plays. After listening twice, repeat it once immediately.<br/>The test takes about 10 minutes. Select START below to begin.',
      beginnerReadSentences: 'This test has three parts: Repeat, Read Sentences and Passage, and Answer Questions. In Part 2, Read Sentences and Passage, there are five sentences and one passage. Use one minute to read them silently, then read them aloud once within one minute at a normal speed, clearly and accurately.<br/>The test takes about 10 minutes. Select START below to begin.',
      beginnerAnswerQuestion: 'This test has three parts: Repeat, Read Sentences and Passage, and Answer Questions. In Part 3, Answer Questions, there are seven questions. Each question is played twice through your headphones, with about one to two seconds between plays. After listening twice, answer immediately. You have 15 seconds for each answer.<br/>The test takes about 10 minutes. Select START below to begin.',
      intermediateChineseToEnglish: 'This test has two parts. Part 1 is Chinese-to-English Translation, and Part 2 is English Composition.<br/>The test time is 40 minutes. Select START below to begin.',
      intermediateEnglishComposition: 'This test has two parts. Part 1 is Chinese-to-English Translation, and Part 2 is English Composition.<br/>The test time is 40 minutes. Select START below to begin.',
      intermediateReadPassage: 'This test has three parts: Read Passage, Answer Questions, and Picture Description. In Part 1, Read Passage, first read the passage silently for one minute. Then read it aloud clearly and accurately at a normal speed within two minutes.<br/>The test takes about 10 minutes. Select START below to begin.',
      intermediateAnswerQuestion: 'This test has three parts: Read Passage, Answer Questions, and Picture Description. In Part 2, Answer Questions, there are ten pre-recorded questions. Each question is played twice through your headphones. Questions 1 to 5 allow 15 seconds each; Questions 6 to 10 allow 30 seconds each. Answer immediately after each question plays.<br/>The test takes about 10 minutes. Select START below to begin.',
      intermediateDescribePicture: 'This test has three parts: Read Passage, Answer Questions, and Picture Description. In Part 3, Picture Description, you will see one picture and four related questions. Complete your answer within 90 seconds.<br/>The test takes about 10 minutes. Select START below to begin.'
    },
    report: {
      answerReport: 'Answer Report',
      excellent: 'Excellent',
      acceptable: 'Acceptable',
      needsImprovement: 'Needs Improvement',
      subtest: 'Subtest',
      scoringCriteria: 'Criteria',
      score: 'Score',
      scoringSection: 'Section',
      questionType: 'Question Type',
      summaryHeaderIntermediate: ['Subtest', 'Criteria', 'Score'],
      summaryHeaderSpeaking: ['Criteria', 'Section', 'Score'],
      summaryHeaderWriting: ['Section', 'Question Type', 'Score'],
      translationGroup: 'Part 1: Chinese-to-English Translation (40%)',
      compositionGroup: 'Part 2: English Composition (60%)',
      translationCriteria: 'Word choice, grammar, spelling, punctuation, and capitalization',
      compositionCriteria: 'Content relevance, organization, vocabulary and sentence patterns, grammar, spelling, and punctuation',
      singleSentenceGroup: 'Part 1: Single Sentence Writing (50%)',
      paragraphGroup: 'Part 2: Paragraph Writing (50%)',
      sentenceRewriteType: 'A. Sentence Rewrite',
      sentenceMergeType: 'B. Sentence Combining',
      sentenceOrderType: 'C. Reordering',
      pictureWritingType: 'D. Picture Writing',
      speakingAllParts: 'Parts 1, 2, and 3',
      speakingThirdPart: 'Part 3',
      pronunciationCriteria: 'Pronunciation, intonation, and fluency',
      grammarVocabularyCriteria: 'Accuracy and appropriateness of grammar and vocabulary',
      speakingFormula: 'GEPT official score formula: total score = ({a}+{b}) x 10 = {score}',
      speakingFormulaDefault: 'GEPT official score formula: total score = (A+B) x 10',
      intermediateWritingFormula: 'GEPT official score formula: [(Part 1 score) x 20 x 40%] + [(Part 2 score) x 20 x 60%]',
      elementaryWritingFormula: 'GEPT official score formula: ((Part 1 score / 30) + (Part 2 score / 5)) x 50',
      previousType: 'Go to {type}',
      restartType: 'Restart This Section'
    },
    modal: {
      grading: 'Reviewing...',
      comprehensiveAdvice: 'Overall Advice',
      paragraphStructure: 'Paragraph Structure:',
      structureAnalysis: 'Structure Analysis',
      content: 'Content:',
      organization: 'Organization:',
      grammar: 'Grammar & Sentence Structure:',
      vocabulary: 'Vocabulary & Spelling:',
      grammarSpellingAdvice: 'Grammar and Spelling Suggestions',
      originalSentence: 'Original Sentence:',
      revisionAdvice: 'Suggestion:',
      revisedSentence: 'Revised Sentence:'
    },
    mic: {
      notAllowed: 'Click the lock icon on the left side of the address bar and allow microphone access.',
      notFound: 'No microphone was detected. Please check your device or use another device.',
      notFoundShort: 'No microphone was detected. Please check that your device is connected.',
      notReadable: 'The microphone may be used by another app. Please try again later.',
      security: 'Please open this feature on an HTTPS website.',
      default: 'Unable to enable the microphone. Please check your device and browser settings.',
      unsupported: 'This browser does not support microphone features. Please use Chrome or Edge.',
      initFailed: 'Recorder initialization failed. Please refresh or switch browsers.',
      initFailedShort: 'Recorder initialization failed',
      startFailed: 'Unable to start recording. Please check microphone permission and device settings.',
      startFailedShort: 'Unable to start recording',
      permissionDenied: 'Microphone access was not allowed. Please enable it in your browser settings.',
      noDevice: 'No microphone was detected. Please use another device or an external microphone.'
    }
  },
  AiHome: {
    start: 'START',
    recent_route: {
      user_guide: 'User Guide',
      letter_generate: 'Generate Letter',
      speech_generate: 'Generate Speech Script',
      ai_correction: 'AI Correction',
      business_context: 'Business Context',
      daily_context: 'Daily Context'
    },
    conversation: {
      business_english: 'Business English Conversation',
      daily_english: 'Daily English Conversation',
      monthly_topic: 'Monthly Featured Topic',
      adults_free_talk: 'Adults Free Talk',
      kids_free_talk: 'Kids Free Talk'
    },
    intro: {
      service_features: 'Service Features',
      service_features_desc: 'AI Assistant combines advanced AI language processing with intelligent algorithms to help you quickly generate business letters and English speech scripts, and provides AI speaking practice. Whether you need to write an English email to a client, prepare an important speech, or improve your speaking skills in spare moments, AI Assistant is a useful support tool.',
      points_desc_title: 'Points',
      points_desc: 'This section uses a points system. Initial points are provided based on your company plan so learners can try AI services. If your points run out, you can purchase more to continue using AI Assistant.',
      guide: 'User Guide',
      choose_type: 'Choose Type',
      choose_type_desc: 'Select the content you want to generate from the left menu.',
      input_data: 'Enter Information',
      input_data_desc: 'Enter or speak the required information in the specified fields, submit it, and wait while AI Assistant completes the task.',
      view_result: 'View Results',
      view_result_desc: 'After AI Assistant finishes writing, review whether the generated content fits your needs. You can also revise and adjust it as needed.',
      more_features: 'More Features',
      more_features_desc: 'Use dictionary lookup, translation, play all, AI suggestions, and more details for further learning. For more inspiration, regenerate the content or choose a different scenario for more interactive practice.'
    },
    common: {
      placeholder_answer: 'Please enter your answer...',
      total_chars_pre: 'Total ',
      total_chars_post: ' characters',
      upload_image: 'Upload Image',
      start_correction: 'Start Correction',
      please_select: 'Please select',
      speaking_practice: 'Speaking Practice',
      japanese_speaking_practice: 'Japanese Speaking Practice',
      deduct_points: ' generation deducts: ',
      edit_letter_info: 'Edit Letter Info',
      edit_speech_info: 'Edit Speech Info',
      ph_disabled_summary: 'EX: Sincerely invite the other party to participate in the upcoming business meeting to explore opportunities and create the future together. The meeting is scheduled for the 13th of next month.',
      confirm: 'Confirm',
      return_edit: 'Return to Edit',
      close: 'Close',
      clear: 'Clear',
      restart: 'Restart',
      on: 'On',
      off: 'Off',
      cancel: 'Cancel',
      audio_not_supported: 'Your browser does not support audio playback.'
    },
    follow: {
      title: 'Shadowing Practice',
      input_hint: 'Please enter text for shadowing practice.',
      play_hint: 'Please click "Play All" to listen to the full audio, or click the right microphone for sentence-by-sentence shadowing practice.',
      record: 'Record',
      title_excellent: 'EXCELLENT!',
      title_great: 'GREAT!',
      title_good: 'GOOD!',
      title_try_again: 'TRY AGAIN!',
      score_excellent: 'Excellent',
      score_good: 'Good',
      score_needs_improvement: 'Needs Work',
      play_original: 'Play Original',
      your_record: 'Your Recording'
    },
    correction: {
      result_title: 'AI Correction Results',
      upload_hint: 'Please enter text or click the upload image button below to convert an image to text.'
    },
    letter: {
      Letter: 'Business Letter',
      Sender_Information: 'Sender Information',
      Sender_Name: 'Sender Name',
      Sender_Company: 'Sender Company',
      Recipient_Information: 'Recipient Information',
      Recipient_Name: 'Recipient Name',
      Recipient_Company: 'Recipient Company',
      Letter_Information: 'Letter Information',
      Subject: 'Subject',
      Summary: 'Summary (max. 100 characters)',
      required: '*This field is required',
      ph_s_name: 'e.g., Emily',
      ph_s_company: 'e.g., ABC Company',
      ph_r_name: 'e.g., David',
      ph_r_company: 'e.g., XYZ Company',
      ph_subject: 'e.g., Discussion on Project Collaboration Details',
      ph_summary: 'e.g., Regarding the details of this new product project collaboration, focusing on the launch schedule, collaboration details, and profit-sharing model, we hope to arrange a face-to-face meeting with your company next week to facilitate our business development.'
    },
    speech: {
      English_Speech_Script: 'English Speech Script',
      Speech_Information: 'Speech Information',
      Topic: 'Topic',
      Type: 'Type',
      Audience: 'Audience',
      Occasion: 'Occasion',
      Summary: 'Summary (max. 100 characters)',
      ph_topic: 'e.g., New Product Introduction',
      ph_audience: 'e.g., Major Corporate Clients',
      type_meeting: 'Meeting Presentation',
      type_proposal: 'Project Proposal',
      type_motivational: 'Motivational Speech',
      type_knowledge: 'Knowledge Sharing',
      type_elevator: 'Elevator Pitch',
      type_product: 'Product Demonstration',
      occ_internal: 'Internal Project Meeting',
      occ_external: 'External Business Communication',
      occ_results: 'Results Presentation and Knowledge Sharing',
      occ_motivation: 'Motivation and Other Information Delivery',
      ph_summary: 'e.g., This speech will present the newly launched AI product, explaining its advantages and features to help enterprises improve operational efficiency and innovative competitiveness.'
    },
    rule: {
      Total_Points: 'Current Total Points',
      Instructions: 'Instructions',
      AI_Generation: 'AI Generation',
      AI_Review_Instructions: 'AI Correction Instructions',
      Note: 'Note',
      Definition: 'Definition',
      privacy_and_security: 'Privacy and Security',
      review_again: 'Please review again',
      per_letter_generation: 'Letter generation deducts',
      per_speech_generation: 'Speech script generation deducts',
      per_AI_generation: ' AI correction deducts',
      Friendly_Reminder: 'Notice',
      point: 'points',
      letter: 'Letter',
      speech: 'Speech Script',
      commercial_letter: 'Business Letter',
      letter_inst_desc: 'Please fill in the sender and recipient information first, then enter the letter details.',
      letter_def_desc: 'After AI Assistant generates the content, you can further adjust the letter details based on your actual needs.',
      letter_privacy_desc: 'When entering information, please be careful not to disclose your own or others\' personal or private information.',
      letter_review_desc: 'This business letter is automatically generated by AI Assistant. Please review and verify the details before use.',
      speech_inst_desc: 'Please fill in the Topic and Audience in Chinese, select the Type and Occasion, and provide a brief summary in Chinese describing the key points of the speech.',
      speech_gen_desc: 'After clicking START, AI will automatically generate a speech script based on your input.',
      speech_note_desc: 'Please confirm the text content before generation and do not disclose company or personal confidential information. This speech script is automatically generated by AI; please review and verify the content yourself.',
      correct_inst_desc: 'Please enter the English content or click the Upload Image button below, then click Start Correction.',
      correct_review_desc: 'After clicking Start Correction, AI will review English vocabulary, grammar, and sentence structure, providing suggestions for Grammar and Vocabulary Correction and Overall Feedback. Errors in the original text will be highlighted in red so you can spot and fix them more easily. AI will also generate an AI Sample based on the uploaded content for reference.',
      correct_note_desc: 'Please confirm the text content before correction and do not disclose company or personal confidential information. This {type} is automatically corrected by AI; please review and verify the content yourself.',
      follow_mic: 'Please click the microphone',
      follow_mic_desc: ' to start recording.',
      follow_play: 'Please click Play Original Sentence',
      follow_play_desc: ' to listen to the teacher demonstration audio.',
      follow_my_record: 'Please click My Recording',
      follow_my_record_desc: ' to play your recorded audio.',
      follow_history: 'Please click Records',
      follow_history_desc: ' to view your personal recording practice history.'
    },
    swal: {
      rules_title: 'Terms of Use',
      got_it: 'Got it',
      current_points: 'Current Total Points: ',
      points_desc: 'This section provides initial points based on your corporate plan to experience AI services.<br/>Points will be automatically deducted each time you use the following services.',
      speaking_practice: 'Speaking Practice: 1 point per use',
      business_letter: 'Business Letter: 20 points per use',
      speech_script: 'Speech Script: 20 points per use',
      insufficient_points: 'Insufficient Points',
      confirm_generate: 'Start generating {type}?',
      confirm_correct: 'Start correcting {type}?',
      current_points_html: 'Current Total Points <span style="color: #F30000;">{points}</span>',
      deduct_20_points: 'Deducts 20 points',
      points_after_html: 'Points After Deduction <span style="color: #F30000;">{points}</span>',
      contact_cs: 'Please contact customer service to purchase more points.',
      generate_fail: 'Generation Failed',
      generate_fail_msg: 'Oops! Something went wrong. Please give me another chance!',
      translate_success: 'Translation Complete',
      system_error: 'System error. Please try again later.',
      confirm_modify: 'Are you sure you want to modify the {type} info?',
      stay_on_page: 'Stay on this page',
      practice_deduct_desc: 'For AI speaking practice, 1 point will be deducted each time you submit.',
      points_or_expired: 'Insufficient points or time expired',
      please_reinput: 'Please re-enter',
      tips_html_2: 'Speaking practice deducts: <span class="text-red-main-ai">1</span> point each time',
      tips_html_3: 'Instructions:',
      tips_html_4: '1. Click {img1} to speak your response, then click {img2}. Points are deducted upon submission.',
      tips_html_5: '2. Click {img1} to reference the AI response and practice saying it.',
      tips_html_6: '3. Click {img1} to enter Chinese text for translation.',
      tips_html_7: '4. Click {img1} to listen to your recording.',
      tips_html_8: '5. Click {img1} to see AI feedback and improve for next time.',
      tips_html_9: '6. If the AI response is unexpected, please modify the text or click refresh.',
      device_test: 'Device Test',
      device_test_desc: 'Please speak into the microphone, and the line will move with your voice.<br/>If there is no response, please make sure microphone permission is enabled.'
    },
    result: {
      play_all: 'Play All',
      font_small: 'Small Font',
      font_normal: 'Normal Font',
      font_large: 'Large Font',
      translation: 'Translation',
      dict_mode: 'Dictionary Mode',
      download: 'Download',
      tab_grammar: 'Grammar & Vocabulary Correction',
      tab_feedback: 'Overall Feedback',
      tab_sample: 'AI Sample',
      shadowing: 'Shadowing Practice',
      grammar_advice_desc: 'Below are {count} grammar and vocabulary suggestions to help improve your accuracy and overall English proficiency:',
      original_sentence: 'Original: ',
      suggestion: 'Suggestion: ',
      explanation: 'Explanation: ',
      salutation: 'Salutation: ',
      body: 'Body: ',
      closing: 'Closing & Signature: ',
      overall_feedback: 'Overall Feedback: ',
      copy_success: 'Successfully copied',
      copy_fail: 'Something went wrong'
    },
    chat: {
      chinese_input: 'Chinese Input',
      ai_suggest: 'AI Suggestion',
      placeholder_active: 'Click the Microphone to record a response, or click AI to generate a suggestion.',
      placeholder_disabled: 'Chat history is for viewing only.',
      submit: 'Submit',
      choose_topic: 'Please select a topic for a stress-free interactive conversation practice!',
      speaking_practice: 'Speaking Practice',
      what_to_do_in_topic: 'What would you like to do in {topic}?',
      scenario_shadowing: 'Scenario Shadowing Practice',
      scenario_conversation: 'Scenario Conversation Practice',
      scenario_selection: 'Scenario Selection',
      chinese_translation: 'Translation',
      you_have_selected: 'You have selected: ',
      start_conversation_practice: 'Start Conversation Practice',
      start_stop_record: 'Start/Stop Recording',
      accent_us: 'American Accent',
      accent_uk: 'British Accent',
      accent_au: 'Australian Accent',
      accent_in: 'Indian Accent',
      play_audio: 'Play Original Audio',
      my_recording: 'My Recording',
      more_explanation: 'More Details',
      in_other_words: 'Paraphrase',
      refresh: 'Refresh',
      ph_translate_input: 'Please enter the Chinese text you want to translate here.',
      playback_speed: 'Playback Speed',
      speed: 'Speed',
      text_display: 'Text Display',
      show_subtitle: 'Show Subtitles',
      hide_subtitle: 'Hide Subtitles',
      save_settings: 'Save Settings',
      chat_settings: 'Chat Settings',
      save_confirm_title: 'Save Confirmation',
      save_confirm_msg: 'Would you like to save this chat record? Saved records can be accessed later for practice and review.',
      save_note: 'Note: Each record is unique. To start a new practice session with the same topic, click Restart.',
      save_success: 'Saved Successfully',
      view_records_score: 'View Scores',
      continue_chatting: 'Continue Chatting',
      history_title: 'My Chat Records',
      rating_title: 'My Chat Scores',
      time: 'Time',
      scene: 'Scene',
      topic: 'Topic',
      first_saved_at: 'First Saved',
      last_updated_at: 'Last Updated',
      updated_at: 'Updated At',
      scene_topic: 'Scene / Topic',
      function: 'Actions',
      sentence_score: 'Sentence Score',
      chat_content: 'Chat Content',
      continue_conversation: 'Continue Conversation',
      sample_scene_topic: 'Airport > Flight Inquiry',
      sample_voice_setting: 'Female / British Accent'
    },
    ocr: {
      popup_title: 'Image to Text',
      step1: 'Select & Upload',
      step2: 'Crop Image',
      step3: 'Recognize',
      step4: 'Verify & Edit',
      upload_drag_hint: 'Drag files here, or click the button to upload an image',
      upload_limit_hint: 'File size must be less than 10MB, and image dimensions must be under 10000px',
      btn_upload: 'Upload Image',
      btn_reupload: 'Re-upload Image',
      btn_confirm_submit: 'Confirm and Submit',
      btn_confirm_text: 'Confirm Text',
      btn_input_submit: 'Input',
      err_not_image: 'Please select an image file (e.g., .jpg or .png)',
      err_size_limit: 'File size cannot exceed 10MB',
      err_pixel_limit: 'Image dimensions cannot exceed 10000 pixels',
      crop_guide_hint: 'Drag the handles to select the image area to crop',
      recognizing_hint: 'Recognizing, please wait...',
      recognition_complete: 'Recognition complete!',
      recognition_fail_hint: 'Recognition failed. Please check whether the image format, file size under 10MB, and image dimensions under 10000px meet the upload requirements.',
      edit_hint: 'Click the text to make corrections',
      recognition_warning_hint: 'AI text recognition results may vary depending on handwriting neatness, paper cleanliness, or photo clarity. Please review and correct the text before confirming.'
    }
  },
  Course: {
    Description_video: 'Learning Videos',
    Interactive_learning: 'Interactive Learning',
    Unit_test: 'Unit Test',
    Practice: 'Review Test',
    Record_study_time: 'Record study time'
  },
  Personal: {
    PersonalArea: 'My Account',
    Info: {
      Total_study_time: 'Total Study Time',
      Number_of_courses_passed: 'Passed Courses',
      Number_of_monthly_exams: 'Monthly Exams Completed',
      First_time_login: 'First Time Login'
    },
    Updated_password: {
      Change_password: 'Change Password',
      Name: 'Name',
      Email: 'Email',
      Current_password: 'Current Password',
      New_password: 'New Password',
      Confirm_password: 'Confirm New Password',
      Save: 'Save',
      Company: 'Company',
      Class: 'Class',
      Period: 'Period',
      Email_remind: 'Please enter your email.',
      Change_account_remind: 'Not available to change your account.',
      Current_password_remind: 'Please enter your current password.',
      New_password_remind: 'Password must contain characters A-Z, a-z or digit 0-9.',
      Reenter_password_remind: 'Please reenter your new password.'
    },
    Target: {
      Target: 'Learning Targets',
      Goal: 'Target',
      Completed: 'Completed',
      Result: 'Result',
      Point: 'point(s)',
      Unit: 'unit(s)',
      Time: 'time(s)'
    },
    Record: {
      Learning_records: 'Learning Records',
      View_all: 'View All',
      Date_settings: 'Period',
      Study_Time: 'Total Study Time',
      Number_of_completed_courses: 'Unit Test Passed',
      Number_of_review_test_passed: 'Review Test Passed',
      Details: 'Details',
      Course_categories: 'Categories',
      History: 'Recent Learning History',
      Unit_test_score: 'Unit Test Score',
      Go_to_course: 'Go to Course',
      Writing: 'Writing'
    },
    Collection: {
      Keep: 'Keep',
      Vocabulary: 'Vocabulary',
      Lesson: 'Lessons',
      Enter_course: 'Go to Course',
      Source_course: 'Go to Course'
    },
    Exam: {
      ExamArea: ' Exam Zone',
      Placement_test: 'Placement Test',
      Result: 'Level (CEFR)',
      Exam_date: 'Test Date',
      Month: 'Month',
      Test_time: 'Test Time',
      Listening_score: 'Listening Score',
      Reading_score: 'Reading Score',
      State: 'State',
      Total_score: 'Total Score',
      Monthly_mock_test: 'Mock Test',
      More_practice: 'More Practice',
      Updated_exam_date: 'Updated exam date',
      Number_of_exercises: 'Practice Time',
      Start: 'Start',
      Details: 'Details'
    }
  }
}
